import { numberFormatters } from "common/number-formatters";
const MIN_RELATIVE_PROGRESS = 0;
const MAX_RELATIVE_PROGRESS = 0.99;
const calculateRelativeProgress = (value, lowerBound, upperBound) => {
    const absoluteProgress = value - lowerBound;
    const boundaryRange = upperBound - lowerBound;
    let relativeProgress = boundaryRange ? absoluteProgress / boundaryRange : 0;
    relativeProgress = Math.min(Math.max(relativeProgress, MIN_RELATIVE_PROGRESS), MAX_RELATIVE_PROGRESS);
    // Round to 2 decimal places
    return Math.round(relativeProgress * 100) / 100;
};
const createTooltip = (category, value, format) => {
    const formattedValue = numberFormatters(value, format);
    return `<div>${category}: ${formattedValue}</div>`;
};
const calculateRankBasedValue = (value, ranking, boundaries) => {
    const lowerBound = boundaries[ranking - 1];
    const upperBound = boundaries[ranking];
    const relativeProgress = calculateRelativeProgress(value, lowerBound, upperBound);
    return (ranking - 1) + relativeProgress;
};
const getCustomResult = (param, value, rankBasedValue) => {
    const customResult = {
        category: param.category,
        format: param.format,
        rankBasedValue,
        tooltip: createTooltip(param.category, value, param.format),
        value
    };
    return customResult;
};
export const highchartsRadarChart = (params) => (args) => {
    const element = args.visitable;
    if (!args.context.staticData.customResult?.length) {
        args.context.staticData.customResult = [];
    }
    params.forEach((param) => {
        if (!args.context.staticData.customResult?.some((x) => x.category === param.category)) {
            const measures = element?.data ? element?.data[0].measures : element.measures;
            const value = measures?.[param.id];
            const ranking = measures?.[param.ranking];
            const boundaries = [
                measures?.[param.bottom5],
                measures?.[param.q1],
                measures?.[param.q2],
                measures?.[param.q3],
                measures?.[param.top5]
            ];
            const rankBasedValue = calculateRankBasedValue(value, ranking, boundaries);
            const customResult = getCustomResult(param, value, rankBasedValue);
            args.context.staticData.customResult?.push(customResult);
        }
    });
};
